export default "__VITE_ASSET__SfuC8HUG__"